import React from 'react';
import ReactDOM from 'react-dom/client';
import * as Sentry from "@sentry/react";
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import './index.css';
import '@fontsource/roboto/300.css';
import '@fontsource/roboto/400.css';
import '@fontsource/roboto/500.css';
import '@fontsource/roboto/700.css';
import { Layout } from './components/Layout';
import WithServices from './components/WithServices';
import { Admin } from './pages/Admin';
import AdminHistory from './pages/AdminHistory/AdminHistory';
import { AdminManageRequests } from './pages/AdminManageRequests';
import { NotFound } from './pages/NotFound';
import StudyRequest from './pages/StudyRequest/StudyRequest';
import {
	HistoryProvider,
	RequestAttachmentProvider,
	StudentProvider,
	StudyRequestProvider,
} from './services';
import { Auth0Provider } from '@auth0/auth0-react';
import AdminManageStudents from './pages/AdminManageStudents/AdminManageStudents';
import { AdminResponsiblePerson } from './pages/AdminResponsiblePerson';
import { UserProvider } from './services/user.service';
import {BasicFlowStudyRequest} from "./pages/BasicFlowStudyRequest";

Sentry.init({
	dsn: "https://0c8fdcf72778145e46f6a8b8f2105e7e@o1307230.ingest.sentry.io/4506091476549632",
	integrations: [
	  new Sentry.BrowserTracing({
		// Set 'tracePropagationTargets' to control for which URLs distributed tracing should be enabled
		tracePropagationTargets: ["localhost", /^https:\/\/request\.victory-drones\.store/],
	  }),
	  new Sentry.Replay(),
	],
	// Performance Monitoring
	tracesSampleRate: 1.0, // Capture 100% of the transactions
	// Session Replay
	replaysSessionSampleRate: 0.1, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
	replaysOnErrorSampleRate: 1.0, // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
});

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);
root.render(
	<Auth0Provider
		domain={process.env.REACT_APP_DOMAIN || ''}
		clientId={process.env.REACT_APP_CLIENT_ID || ''}
		redirectUri={`${window.location.origin}/admin`}
		advancedOptions={{
			defaultScope: 'openid profile email',
		}}
	>
		<React.StrictMode>
			<Layout>
				<BrowserRouter>
					<Routes>
						<Route
							path="/"
							element={WithServices(StudyRequest, [StudyRequestProvider])(
								{}
							)}
						/>

						<Route
							path="/basicFlow"
							element={WithServices(BasicFlowStudyRequest, [StudyRequestProvider])(
								{}
							)}
						/>

						<Route path="admin" element={<Admin />}>
							<Route
								index
								element={WithServices(AdminManageRequests, [
									RequestAttachmentProvider,
									StudentProvider,
									StudyRequestProvider,
								])({})}
							/>
							<Route
								path="study-request"
								element={WithServices(StudyRequest, [
									StudyRequestProvider,
								])({})}
							/>
							<Route
								path="students"
								element={WithServices(AdminManageStudents, [
									StudentProvider,
								])({})}
							/>
							<Route
								path="history"
								element={WithServices(AdminHistory, [HistoryProvider])(
									{}
								)}
							/>
							<Route
								path="open-basic-access"
								element={WithServices(AdminResponsiblePerson, [
									UserProvider,
								])({})}
							/>
						</Route>
						<Route path="*" element={<NotFound />} />
					</Routes>
				</BrowserRouter>
			</Layout>
		</React.StrictMode>
	</Auth0Provider>
);
